/* eslint-disable react-hooks/exhaustive-deps */
import { Box, css, HStack } from '@chakra-ui/react';
import { useMemo } from 'react';
import { Text } from '../../../components/atoms/Text';
import { useTheme } from '../../../contexts/ThemeProvider';
import useIsMobile from '../../../hooks/use-is-mobile';
import { ICategory } from '@/service/categories/types';
import { useCategories } from '@/service/categories/hooks';

const FilterTag = ({ id, icon, name, selected, primaryColor, last, onClick }: ICategory) => {
  return (
    <Box paddingRight={last ? '20px' : '0px'}>
      <HStack
        onClick={() => onClick(id)}
        minWidth="fit-content"
        cursor="pointer"
        whiteSpace="nowrap"
        spacing={1}
        border={`1px solid ${selected ? primaryColor : '#747474'}`}
        borderRadius={'8px'}
        padding="8px"
      >
        <Box as="i" className={icon} color={selected ? primaryColor : '#747474'} fontSize="16px" />
        <Text
          lineHeight={'20.16px'}
          color={selected ? primaryColor : '#747474'}
          fontWeight={'Glory'}
          fontStyle={'500'}
          fontSize={'16px'}
        >
          {name}
        </Text>
      </HStack>
    </Box>
  );
};

export function Categories({
  selectedCategories,
  setSelectedCategories,
}: {
  selectedCategories: number[];
  setSelectedCategories: (categories: number[]) => void;
}) {
  const { data: categories } = useCategories();
  const { colors } = useTheme();

  const isMobile = useIsMobile();

  function toggleCategory(categoryId: number) {
    const newCategories = [...(selectedCategories || [])];
    const index = newCategories.indexOf(categoryId);

    if (index === -1) {
      newCategories.push(categoryId);
    } else {
      newCategories.splice(index, 1);
    }

    if (newCategories.length > 0) setSelectedCategories(newCategories);
    else setSelectedCategories([]);
  }

  const orderedCategories = useMemo(
    () =>
      categories
        ?.map((c) => ({
          ...c,
          selected: selectedCategories.indexOf(c.id) !== -1,
        }))
        .sort((a) => (a.selected ? -1 : 1))
        .map((c, index) => (
          <FilterTag
            {...c}
            key={c.id}
            last={index === categories.length - 1}
            icon={`fas fa-${c.icon}`}
            onClick={() => toggleCategory(c.id)}
            primaryColor={colors.primaryColor}
          />
        )),
    [categories, colors.primaryColor, selectedCategories, toggleCategory]
  );

  return (
    <>
      <Box
        overflowX="auto"
        whiteSpace="nowrap"
        width={'100%'}
        css={css({
          scrollbarWidth: !isMobile ? 'auto' : 'none',
          '::-webkit-scrollbar': { display: !isMobile ? '' : 'none' },
          WebkitOverflowScrolling: 'touch',
          border: '0 none',
        })}
      >
        <HStack spacing={2}>{orderedCategories}</HStack>
      </Box>
    </>
  );
}
